/**
* Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd.
* pdf上传（无弹框多文件上传）
* */
<template>
  <div id="xk_upload_pdfs">
    <el-upload
        drag
        v-loading="loading"
        :limit="max"
        :accept='accept'
        :multiple="multiple"
        ref="upload"
        :on-change="beforeChange"
        :on-progress="onProgress"
        :on-error="onUploadError"
        :show-file-list="files.length > 0 ? true : false"
        :file-list="files"
        :action="action"
        :on-remove="onRemove"
        :on-exceed="onExceed"
        :on-preview="onPreview"
        :auto-upload="false">
      <div class="el-upload__text">拖拽{{ accept }}文件到本区域上传</div>
      <div class="el-upload__text">或者<em>点击这里</em>上传</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'upload_pdfs',
  props: {
    multiple: {
      default() {
        return true
      }
    },
    action: {
      // 上传的七牛云地址
      default() {
        let url = "http://up-z1.qiniu.com";
        if (window.location.protocol === "http:") {
          url = "http://up-z1.qiniu.com";
        } else if (window.location.protocol === "https:") {
          url = "https://upload-z1.qbox.me";
        }
        return url;
      },
    },
    nameCustom: { // 是否自定义名称
      default() {
        return true
      }
    },
    accept: { // 是否自定义名称
      default() {
        return 'pdf'
      }
    },
    urls: { // 已上传文件列表
      default() {
        return []
      }
    },
    max: { // 上传最大值
      default() {
        return 0
      }
    }
  },
  watch: {
    urls: {
      handler() {
        if (this.urls && this.urls.length) {
          this.files = this.urls
        }

      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      files: [], // 已上传文件列表+待上传文件
      loading: false
    }
  },
  async mounted() {
  },
  methods: {
    onExceed() {
      this.$message.warning(`只能上传${this.max}份文件`)
    },
    onPreview(file){
      window.open(window.configure.qiniuUrl + '/' + file.url)
    },
    /**
     * 删除已上传文件
     * @param index
     */
    onRemove(file) {
      this.files = this.files.filter((item) => item.url !== file.url)
      this.$emit('update:urls', this.files)
    },
    /**
     * 待上传文件变化
     * @param val
     */
    async beforeChange(file, fileList) {
      // 检查文件类型
      const fileType = file.raw.type.split('/')[1];
      const acceptedTypes = this.accept.split(',').map(type => type.replace('.', ''));
      if (!acceptedTypes.includes(fileType)) {
        this.$message.error(`不支持${fileType}文件类型，请上传 ${this.accept} 格式的文件`);
        // 从 fileList 中移除不合格的文件
        const index = fileList.indexOf(file);
        if (index > -1) {
          fileList.splice(index, 1);
        }
        return false;
      }

      this.$emit('isUpLoad', true)
      this.loading = true;
      
      try {
        let formData = new FormData();
        let qiniuToken = await this.getQiniuTokenFn();
        formData.append("token", qiniuToken);
        formData.append("file", file.raw);
        formData.append("key", new Date().getTime() + '.' + file.raw.type.split('/')[1]);

        let data = await this.$axios.post(this.action, formData);

        if (data && data.hash) {
          this.files.push({
            name: data.key,
            url: data.key,
          })
          this.$emit('update:urls', this.files)
        } else {
          throw new Error('上传失败：服务器响应异常')
        }
      } catch (error) {
        file.status = 'error'
        this.$message.error(`文件 ${file.name} 上传失败：${error.message || '网络错误'}`)
        this.onUploadError(error, file)
        return
      }
      console.log(this.multiple, fileList.length, this.files.length)
      // 在多选模式下，检查是否所有文件都已上传完成
      if (!this.multiple || (this.multiple && fileList.length === this.files.length)) {
        this.loading = false;
        this.$emit('isUpLoad', false)
      }
    },
    
    /**
     * 处理上传失败
     * @param {Error} err 错误对象
     * @param {Object} file 文件对象
     */
    onUploadError(err, file) {
      // 从文件列表中移除失败的文件
      this.files = this.files.filter(f => f.name !== file.name)
      this.$emit('update:urls', this.files)
      
      // 如果所有文件都已处理完（成功或失败），关闭加载状态
      const pendingFiles = this.$refs.upload.uploadFiles.filter(f => f.status === 'uploading')
      if (pendingFiles.length === 0) {
        this.loading = false
        this.$emit('isUpLoad', false)
      }
    },
    onProgress(event, file) {
      console.log(event, file)
    }
  }
}
</script>

<style lang="less">
#xk_upload_pdfs {
  .tool-tag {
    height: 40px;
    align-items: center;
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 5px;

    .el-input {
      flex: 1;
      margin-right: 20px;

      input {
        border-color: #409eff;
      }
    }

    .el-icon-close {
      position: static;
    }
  }
  .el-upload {
    display: inline;
  }

  .el-upload-dragger {
    margin-top: 10px;
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .attachment {
    max-height: 180px;
    overflow-y: auto;

    .el-tag + .el-tag {
      margin-top: 10px;
    }
  }
}
</style>
